import type { TypedWrappedFieldProps } from "redux-form";

import type { OptionBase } from "@braintrust/braintrust-ui-components";
import { Box, Button, Stack } from "@braintrust/braintrust-ui-components";

type PaymentConditionsValue =
  "client_pays_directly" | "braintrust_pays_off_platform" | null;

type PaymentConditionsFieldProps =
  TypedWrappedFieldProps<PaymentConditionsValue>;

const OPTIONS: OptionBase<PaymentConditionsValue>[] = [
  {
    value: "braintrust_pays_off_platform",
    label: "Braintrust pays talent off platform",
  },
  {
    value: "client_pays_directly",
    label: "Client will pay talent directly",
  },
];

export const PaymentConditionsField = ({
  input,
}: PaymentConditionsFieldProps) => {
  return (
    <Stack direction="row" sx={{ gap: 1, mb: 4 }}>
      {OPTIONS.map((option) => {
        const isSelected = input.value === option.value;
        return (
          <Button
            key={option.value}
            shape="squared"
            sx={{
              height: "40px !important",
              minHeight: "unset !important",
              padding: "0 16px !important",
            }}
            onClick={() => {
              input.onChange(isSelected ? null : option.value);
            }}
            variant={isSelected ? "positive" : "white-grey"}
            startIcon={
              isSelected ? (
                <Box
                  component="span"
                  sx={{
                    display: "inline-block",
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    flexShrink: 0,
                  }}
                />
              ) : undefined
            }
          >
            {option.label}
          </Button>
        );
      })}
    </Stack>
  );
};
